/** Nombre/apellido de persona: title case al mostrar. */
export function formatPersonName(value) {
  const s = String(value ?? '').trim().replace(/\s+/g, ' ');
  if (!s) return '';
  return s
    .split(' ')
    .map((w) => (w ? w.charAt(0).toLocaleUpperCase('es') + w.slice(1).toLocaleLowerCase('es') : ''))
    .join(' ');
}

export function formatFullName(first, last, fallback = '') {
  const full = `${formatPersonName(first)} ${formatPersonName(last)}`.trim();
  return full || fallback || '';
}
